import * as React from 'react';

import { NEWBUILDING_COMPARE_ENABLED_CONFIG } from '../../constants/newbuildingCompare';
import { NewbuildingComparisonButton } from '../../components/NewbuildingComparisonButton';
import { useApplicationContext } from '../../utils/applicationContext';
import { trackAddNewbuildingToComparison, trackDeleteNewbuildingFromComparison } from './tracking';

interface INewbuildingComparisonButtonContainerProps {
  entityId: number;
  label: string;
}

export const NewbuildingComparisonButtonContainer: React.FC<INewbuildingComparisonButtonContainerProps> = ({
  entityId,
  label,
}) => {
  const { config } = useApplicationContext();
  const [isAdded, setIsAdded] = React.useState(false);
  const isNewbuildingCompareEnabled = config.get<boolean>(NEWBUILDING_COMPARE_ENABLED_CONFIG) || false;

  const handleClick = React.useCallback(() => {
    const nextValue = !isAdded;

    if (nextValue) {
      trackAddNewbuildingToComparison({ entityId, label });
    } else {
      trackDeleteNewbuildingFromComparison({ entityId, label });
    }

    setIsAdded(nextValue);
  }, [entityId, isAdded, label]);

  if (!isNewbuildingCompareEnabled) {
    return null;
  }

  return <NewbuildingComparisonButton isAdded={isAdded} onClick={handleClick} />;
};
